import { NgModule } from '@angular/core';
import { AddToCartDirective } from './add-to-cart.directive';

@NgModule({
  exports: [AddToCartDirective],
  declarations: [AddToCartDirective]
})
export class AddToCartModule {}
